export default function setSearchCreatorAction(searchCreator) {
    return {
        type: 'SET_SEARCH_CREATOR',
        payload: searchCreator
    }
}